import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';

export default function AuthGuard({ children }) {
  const { user, loading } = useAuth();
  const lp = useLocalizedPath();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '4rem' }}>
        <div className="spinner" role="status" aria-label="Loading" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={lp('/login')} replace />;
  }

  return children;
}
